'use client';
import { scrollDestroySelector } from '@lib/store/slices/ComponentsSlice';
import { useRef } from 'react';
import { useSelector } from 'react-redux';

export const GalleryScrollContainer = ({ children }) => {
  const scrollDestroy = useSelector(scrollDestroySelector);
  const containerRef = useRef(null);

  return (
    <div ref={containerRef} className={`App ${!scrollDestroy ? '' : 'App--scroll'}`}>
      {children}
    </div>
  );
};
